import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => { localStorage.setItem('cookie-consent', 'accepted'); setVisible(false); };
  const decline = () => { localStorage.setItem('cookie-consent', 'declined'); setVisible(false); };

  if (!visible) return null;

  return (
    <div role="dialog" aria-label="Cookie consent" aria-live="polite"
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="max-w-4xl mx-auto bg-card border border-border rounded-sm shadow-xl p-6 md:flex md:items-center md:gap-6">
        <div className="flex-1 mb-4 md:mb-0">
          <p className="font-serif text-lg text-foreground mb-1">{t('weValuePrivacy')}</p>
          <p className="text-muted-foreground text-sm leading-relaxed">{t('cookieDesc')}</p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button onClick={decline} className="px-5 py-2.5 text-xs tracking-wider uppercase border border-border rounded-sm hover:bg-muted transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2" aria-label={t('decline')}>{t('decline')}</button>
          <button onClick={accept} className="px-5 py-2.5 text-xs tracking-wider uppercase bg-accent text-accent-foreground rounded-sm hover:bg-accent/90 transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2" aria-label={t('accept')}>{t('accept')}</button>
          <button onClick={decline} className="p-1 text-muted-foreground hover:text-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring rounded-sm" aria-label="Close"><X size={16} /></button>
        </div>
      </div>
    </div>
  );
}
